import React from 'react';
import moment from 'moment';
import { icons } from '~/assets';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Grid from '~/components/grid';
import Input from '~/components/input';

interface KycHistoryDialogProps {
  open: boolean;
  dataKyc: any;
  senha: string;
  onClose: () => void;
  onOpenRelease: () => void;
  onPasswordChange: (value: string) => void;
  showOptionsRule: () => boolean;
}

const KycHistoryDialog: React.FC<KycHistoryDialogProps> = ({
  open,
  dataKyc,
  senha,
  onClose,
  onOpenRelease,
  onPasswordChange,
  showOptionsRule,
}) => {
  const hasData = Object.keys(dataKyc || {}).length > 0;
  const motivosReprovacao = Array.isArray(dataKyc?.motivosReprovacao)
    ? dataKyc.motivosReprovacao.filter((motivo) => motivo)
    : [];

  return (
    <Dialog
      widthInPercent={hasData ? 85 : 0}
      icon={icons.exclamation}
      open={open}
      title={<span style={{ color: '#e71037' }}>Detalhes resposta KYC</span>}
      negativeLabel="Voltar"
      positiveLabel="Liberar"
      negativeAction={onClose}
      positiveAction={() => {
        onClose();
        onOpenRelease();
      }}
      buttonDisabledPositive={!showOptionsRule() || !hasData}
      buttonsLeft
    >
      {!hasData ? (
        <span>O cliente está liberado e não possui rejeição!</span>
      ) : (
        <Grid xs={1} sm={2} lg={2} gap={30}>
          <ContainerFlex marginLeft={20}>
            <Input readOnly label="Nome" value={dataKyc?.detalhamento?.nome} />
            <Input
              readOnly
              label="Data Nascimento"
              value={moment(dataKyc?.detalhamento?.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            />
            <Input readOnly label="Nome da Mãe" value={dataKyc?.detalhamento?.nomeMae} />
            <Input readOnly label="Status CPF receita federal" value={dataKyc?.detalhamento?.statusCpf} />
            <Input readOnly label="País do CPF" value={dataKyc?.detalhamento?.paisCpf} />
            <Input readOnly label="Ano da indicação de óbito" value={dataKyc?.detalhamento?.indicacaoObito} />
            <Input
              readOnly
              label="Pessoa politicamente exposta?"
              value={dataKyc?.detalhamento?.politicamenteExposto ? 'SIM' : 'NÃO'}
            />
            <Input readOnly label="Mensagem do provedor" value={dataKyc?.detalhamento?.mensagemRetornada} />
          </ContainerFlex>
          <ContainerFlex marginRight={20}>
            <Input readOnly label="CPF" value={dataKyc?.cpf} />
            <Input readOnly label="Gênero" value={dataKyc?.detalhamento?.genero} />
            <Input readOnly label="Nome do Pai" value={dataKyc.detalhamento?.nomePai} />
            <Input readOnly label="Nacionalidade" value={dataKyc.detalhamento?.nacionalidade} />
            <Input readOnly label="Indicação de óbito" value={dataKyc.detalhamento.indicacaoObito} />
            <Input readOnly label="Está sancionado?" value={dataKyc?.detalhamento?.sancionado ? 'SIM' : 'NÃO'} />
            {motivosReprovacao.length > 0 ? (
              motivosReprovacao.map((motivo, index) => (
                <Input
                  key={`${motivo}-${index}`}
                  readOnly
                  label={
                    motivosReprovacao.length > 1
                      ? `Motivo da reprovação ${index + 1}`
                      : 'Motivo da reprovação'
                  }
                  value={motivo}
                />
              ))
            ) : (
              <Input readOnly label="Motivo da reprovação" value="-" />
            )}
            <Input
              readOnly
              label="Data consulta"
              value={moment(dataKyc.dataUltimaConsulta, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            />
            <Input
              readOnly
              label="Restrito até"
              value={moment(dataKyc.dataRestricao, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            />
          </ContainerFlex>
        </Grid>
      )}
    </Dialog>
  );
};

export default KycHistoryDialog;
